module.exports = __webpack_public_path__ + "bootleggeres_coffee_box_mockup_packaging_design_corrugated_box_arabica4.jpg?914b6eacd868232f090b9960e21a6efe";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/bootleggers/bootleggeres_coffee_box_mockup_packaging_design_corrugated_box_arabica4.jpg
// module id = 27
// module chunks = 0